import { spacing, fontSize, borderRadius } from 'presentations/views/styles';
import Icon from 'presentations/views/components/atoms/Icon';
import {
  stripeBackgroud,
  black,
  gray04,
  gray02,
  primary,
} from 'presentations/views/styles/color';
import React, { ReactNode, SyntheticEvent } from 'react';
import Link from '../../atoms/Link';
import styled from '@emotion/styled';

interface Props {
  label: string;
  url?: string;
  image?: ReactNode;
  onClick?: any;
  isDisabled?: boolean;
}

export default function Component(props: Props) {
  const onClick = (e: SyntheticEvent<HTMLAnchorElement>) => {
    if (props.isDisabled) {
      e.preventDefault();
      return;
    }
    props.onClick(e);
  };

  return (
    <ActionButton
      isDisabled={props.isDisabled}
      target="_blank"
      onClick={onClick}
      href={props.url}
    >
      {props.image && props.image}
      <OpenIcon name="open-in-new" isDisabled={props.isDisabled} />
      <ActionText>{props.label}</ActionText>
    </ActionButton>
  );
}

const ActionButton = styled(Link)<{ isDisabled?: boolean }>`
  height: auto;
  font-weight: normal;
  font-size: ${fontSize(13)};
  color: ${(props) => (props.isDisabled ? gray02 : black)};
  display: inline-flex;
  align-items: center;
  padding: ${spacing(16)} ${spacing(24)};
  background: ${stripeBackgroud};
  border-radius: ${borderRadius(12)};
`;
const ActionText = styled.span`
  display: inline-block;
`;

const OpenIcon = styled(Icon)<{ isDisabled?: boolean }>`
  margin-right: ${spacing(6)};
  color: ${(props) => (props.isDisabled ? gray02 : primary)};
  width: 20px !important;
  height: 20px !important;
`;
